import type { MattersToYouGroup } from "../apis/accessibility";

function hasHadName(group: MattersToYouGroup, name: string): boolean {
  return group.group_name === name || !!group.former_names?.includes(name);
}

/**
 * The "What Matters To You" group a stored onboarding answer points at: by id,
 * then by current name, then by a name the group had before.
 */
export function resolveMattersToYouGroup(
  groups: MattersToYouGroup[],
  saved: { id?: number | null; name?: string | null },
): MattersToYouGroup | undefined {
  const name = saved.name;

  if (typeof saved.id === "number") {
    const byId = groups.find((group) => group.id === saved.id);
    // Ids can be handed out again after a group is removed; a rename always records the old name.
    if (byId && (!name || hasHadName(byId, name))) return byId;
  }

  if (!name) return undefined;

  return (
    groups.find((group) => group.group_name === name) ??
    groups.find((group) => group.former_names?.includes(name))
  );
}
